import { createElement } from 'react';
import url from '../../http/url';
const Videos = function Videos({ imgList, style: styleOption = {}, uploadData, autoplay, }) {
    const defaultValue = [];
    if (uploadData) {
        uploadData.forEach(item => {
            if (item.response.resultCode === 200) {
                defaultValue.push({
                    uid: (new Date()).getTime(),
                    name: item.name,
                    state: "done",
                    url: `${url.url}/image/${item.response.data}`,
                    type: item.response.data.split('.')[1],
                });
            }
        });
    }
    if (imgList) {
        imgList.forEach(item => {
            if (item.imgUrl) {
                const type = item.imgUrl.indexOf('mp4') !== -1 ? 'mp4' : item.imgUrl.indexOf('ogg') !== -1 ? 'ogg' : 'webm';
                defaultValue.push({
                    uid: (new Date()).getTime(),
                    name: item.imgName,
                    state: "done",
                    url: item.imgUrl,
                    type,
                });
            }
        });
    }
    const widthVideo = `${Math.floor(100 / (defaultValue.length || 1))}%`;
    const autoplayObj = autoplay ? 'autoplay' : false;
    return (createElement("div", { style: { height: '200px', ...styleOption } },
        createElement("video", { controls: "controls", autoPlay: autoplayObj, loop: true, style: { width: widthVideo, height: "100%" } },
            defaultValue.map((item, index) => item.type === 'ogg' ? (createElement("source", { src: item.url, key: index, type: "video/ogg" })) :
                item.type === 'mp4' ? (createElement("source", { src: item.url, key: index, type: "video/mp4" })) :
                    (createElement("source", { src: item.url, key: index, type: "video/webm" }))),
            "Your browser does not support the video tag.")));
};
export default Videos;
